import { gql } from '@apollo/client';

export default gql`
  query getHotelBooking($externalReference: String!, $productType: HotelBookingProductType) {
    getHotelBooking(externalReference: $externalReference, productType: $productType) {
      bookingReference
      status
      leadGuestFirstName
      leadGuestLastName
      arrivalDate
      hotelName
      duration
      numberOfGuests
      numberOfRooms
      address
      totalPrice
      totalCommission
      currency
      productType
      rating
      region
      resort
      country
      telephone
      rooms {
        type
        numberOfGuests
        mealBasisId
        mealBasisDescription
      }
    }
  }
`;
